import React, { forwardRef } from "react";
import AppBox from "@/components/AppBox";

interface AppCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const AppCheckbox = forwardRef<HTMLInputElement, AppCheckboxProps>(
  ({ label, checked, indeterminate, onChange, ...props }, ref) => {
    const inputId = `checkbox-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
      <AppBox align="center" gap={2} className="cursor-pointer">
        <div className="relative w-5 h-5 border border-gray-400 rounded-sm flex items-center justify-center">
          <input
            id={inputId}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            ref={(el) => {
              if (el) {
                el.indeterminate = Boolean(indeterminate);
              }
              if (typeof ref === "function") {
                ref(el);
              } else if (ref) {
                ref.current = el;
              }
            }}
            className="absolute opacity-0 w-full h-full cursor-pointer"
            {...props}
          />
          <div
            className={`w-3 h-3 ${
              indeterminate
                ? "bg-gray-600"
                : checked
                ? "bg-green-500"
                : "bg-transparent"
            } transition-colors duration-200 rounded-sm`}
          ></div>
        </div>
        {label && <label htmlFor={inputId} className="text-sm text-gray-700 cursor-pointer">{label}</label>}
      </AppBox>
    );
  }
);

AppCheckbox.displayName = "AppCheckbox";

export default AppCheckbox;